import * as React from "react";
import {
    historicalRowsFadeInTotalDurationInMilliseconds,
    latestJournalEntryFadeInDurationInMilliseconds,
} from "../Data/QuickJournalTypes";
import { IQuickJournalState } from "../Data/QuickJournalTypes";

export function useQuickJournalAnimationEffects({
    state,
    setState,
}: {
    state: IQuickJournalState;
    setState: React.Dispatch<React.SetStateAction<IQuickJournalState>>;
}) {
    const [shouldFadeInHistoricalRows, setShouldFadeInHistoricalRows] =
        React.useState(true);

    React.useEffect(() => {
        const timeoutId = window.setTimeout(
            () => setShouldFadeInHistoricalRows(false),
            historicalRowsFadeInTotalDurationInMilliseconds
        );

        return () => window.clearTimeout(timeoutId);
    }, []);

    React.useEffect(() => {
        if (!state.animatingEntryCreatedAt?.length) {
            return;
        }

        const timeoutId = window.setTimeout(
            () =>
                setState((currentState) => ({
                    ...currentState,
                    animatingEntryCreatedAt: undefined,
                })),
            latestJournalEntryFadeInDurationInMilliseconds
        );

        return () => window.clearTimeout(timeoutId);
    }, [state.animatingEntryCreatedAt]);

    return {
        shouldFadeInHistoricalRows,
    };
}
